import { Component, Input } from '@angular/core';


@Component({
    selector: 'impact-analysis-scope',
    template: require('./impact-analysis-scope.html'),
    styles: [require('./impact-analysis-scope.scss')]
})
export class ImpactAnalysiSscope {
    @Input() public item: any;

    constructor() {}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-scopes-ang7/impact-analysis-scope/impact-analysis-scope.ts